<template>
    <el-table
        :key="tableKey"
        :data="orderList"
        stripe
        style="width: 1200px;margin-left: auto;margin-right: auto"
        >
      

        <el-table-column label="订单" width="300">
            <template slot-scope="scope">
                <span>{{ scope.row.order_id }}</span>
            </template>
        </el-table-column>
        <el-table-column label="展会">
            <template slot-scope="scope">
                <span>{{ scope.row.zhName }}</span>
            </template>
        </el-table-column>
        <el-table-column label="展位号">
            <template slot-scope="scope">
                <span>{{ scope.row.boothCode }}</span>
            </template>
        </el-table-column>
            
        <el-table-column label="总保费" width="80">
            <template slot-scope="scope">
                <span>{{ scope.row.sumPremium }}</span>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
                <div v-if="scope.row.order_status==0">
                    <el-button size="small" type="primary" @click="onPay(scope.row)">去支付</el-button>
                </div>
            </template>
          
        </el-table-column>



    </el-table>
    
</template>
<script>
import http from '../utils/http'
export default {
    created(){
        this.getOrders()
        console.log(this.orderList)
    },
    data() {
      return {
        tableKey: 0,
        orderList:[]
      }
    },
    methods: {
        getOrders(){
            http.fetchGet('/user_orders').then((data)=>{
                console.log(data.data)
                this.orderList = data.data.orderList
            }).catch(err=>{
                console.log(err)
                this.$router.push({
                    path:'/login',
                    name:'Login'
                })
            })

        },
        onPay(order){
            console.log(order)
            // window.location.href = order.payUrl
            http.fetchPost('/pay_url', order).then((data)=>{
                // console.log(data.data)
                window.location.href = data.data.pay_url
            }).catch(err=>{
                console.log(err)
                this.$alert('网络请求失败', {
                    confirmButtonText: '确定',
                    // callback: action => {
                    //   this.$message({
                    //     type: 'info',
                    //     message: `action: ${ action }`
                    //   });
                    // }
                    });
            })
        }
    }
    
}
</script>